import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api, { getImageUrl } from "@/lib/api";
import { DEFAULT_PROJECTS, getStoredProjects } from "@/lib/projectsData";
import { Menu } from "@/components/Menu";
import { Footer } from "@/components/Footer";
import { useRevealObserver } from "@/hooks/useReveal";

const FILTERS = ["Todas", "Hotelería", "Centros Comerciales", "Viviendas"];

export default function Obras() {
  const [projects, setProjects] = useState([]);
  const [filter, setFilter] = useState("Todas");
  const rootRef = useRevealObserver();

  useEffect(() => {
    api.get("/projects")
      .then((r) => setProjects(Array.isArray(r.data) && r.data.length ? r.data : getStoredProjects()))
      .catch(() => setProjects(getStoredProjects()));
    window.scrollTo(0, 0);
  }, []);

  const filtered = filter === "Todas" ? projects : projects.filter((p) => p.sector === filter);

  return (
    <div ref={rootRef} className="bg-[#F3F0EA] text-[#111111] min-h-screen">
      <Menu />
      <header className="px-6 md:px-10 lg:px-16 pt-32 md:pt-40 pb-14" data-testid="obras-header">
        <p className="reveal text-xs uppercase tracking-[0.25em] font-semibold text-[#D94A1E] mb-6">— Proyectos Seleccionados</p>
        <h1 className="reveal text-[15vw] md:text-[10vw] leading-[0.85] tracking-tighter uppercase font-medium">Obras</h1>
        <div className="reveal mt-12 flex flex-wrap gap-x-8 gap-y-3">
          {FILTERS.map((f) => (
            <button
              key={f}
              data-testid={`obras-filter-${f.toLowerCase().replace(/ /g, "-")}`}
              onClick={() => setFilter(f)}
              className={`text-sm uppercase tracking-widest transition-colors duration-300 ${filter === f ? "text-[#D94A1E] font-semibold" : "font-light hover:text-[#D94A1E]"}`}
            >
              {f}
            </button>
          ))}
        </div>
      </header>
      <div className="px-6 md:px-10 lg:px-16">
        <div className="line-reveal border-t border-[#111111]" />
      </div>

      <main className="px-6 md:px-10 lg:px-16 py-20 space-y-24 md:space-y-32" data-testid="obras-list">
        {filtered.map((p, i) => (
          <Link
            key={p.id}
            to={`/obras/${p.slug}`}
            data-testid={`obra-item-${p.slug}`}
            className="reveal grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 group"
          >
            <div className={`img-zoom ${i % 3 === 0 ? "md:col-span-8" : i % 3 === 1 ? "md:col-span-6 md:col-start-7" : "md:col-span-7 md:col-start-3"}`}>
              <img src={getImageUrl(p.hero_image)} alt={p.title} loading="lazy" className={`w-full object-cover ${i % 3 === 1 ? "aspect-[3/4] md:aspect-square" : "aspect-[16/10]"}`} />
            </div>
            <div className={`flex flex-col justify-end ${i % 3 === 0 ? "md:col-span-3 md:col-start-10" : i % 3 === 1 ? "md:col-span-4 md:col-start-1 md:row-start-1" : "md:col-span-2 md:col-start-11"}`}>
              <span className="text-[10px] md:text-xs uppercase tracking-[0.25em] font-semibold text-[#D94A1E]">{p.sector}</span>
              <h2 className="mt-3 text-2xl md:text-3xl uppercase tracking-tight font-medium group-hover:text-[#D94A1E] transition-colors duration-300">{p.title}</h2>
              <div className="mt-5 border-t border-[#111111] pt-3 text-sm font-light space-y-1">
                <p>{p.location}</p>
                <p>{p.year}</p>
              </div>
            </div>
          </Link>
        ))}
        {filtered.length === 0 && (
          <p className="text-lg font-light text-[#111111]/60" data-testid="obras-empty">No hay obras en este sector todavía.</p>
        )}
      </main>
      <Footer />
    </div>
  );
}
